import { Autocomplete, Box, Button, Card, CircularProgress, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { PermissionGuard } from '../../../../../components/PermissionGuard';
import UnauthorizedPage from '../../../../UnAuthorized';
import { DuplicateEntryDataContext } from './MultipleDuplicateSlabCreate';
import { SlabServices } from '../SlabServices';

const SelectCategoryForm = () => {
    const {closeModal,slabInitialData,slabData,setSlabData,selectedSlabData,setSelectedSlabData, urbanTypeList,fetchUrbanTypeList,categoryList, loadingCategoryList, fetchCategoryList, fetchSlabList,paginationModel,setPaginationModel,slabList} = useContext(DuplicateEntryDataContext)
    const [pageTitle, setPageTitle] = useState('Add Slab');
    const {control,handleSubmit,formState:{isDirty},reset,watch,setValue} = useForm({
        mode:'onChange',
        defaultValues:slabData,
    });
    const [isSubmitted,setIsSubmitted] = useState(false);
    const onSubmit = async (data)=>{
        // setIsSubmitted(true);
        console.log("selectedSlabData:",selectedSlabData);
        console.log("data:",slabList);
        const modifiedData =[];
        // for each slab in slabList, create a new slab entry with the selected category and subscription type but other details same as the slab
        slabList.forEach((slab)=>{
            const newSlab = {
                categoryId: selectedSlabData.categoryId,
                SubscriptionUrbanTypeId: selectedSlabData.SubscriptionUrbanTypeId,
                orderStart: slab.orderStart,
                orderEnd: slab.orderEnd,
                subscriptionFee: slab.subscriptionFee,
                subscriptionFeeWithGst: slab.subscriptionFeeWithGst,
                status: false
            };
            modifiedData.push(newSlab);
        });
        console.log("modifiedData to be saved:",modifiedData);
        Swal.fire({
            title:'Processing',
            text:'Please wait while we processing Submission request...',
            didOpen: () => {
                Swal.showLoading();
            }
        })
        try{
            const saveresponse = await SlabServices.addMultipleSlabs(modifiedData);
            if(saveresponse.success == '1'){
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: saveresponse?.message ||'Data saved successfully',
                })
                fetchSlabList();
                reset(slabInitialData);

            }else if(saveresponse.success == '0'){
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: saveresponse.message || 'failed to save data',
                })
            }
        }catch (error){
            console.log("error:",error)
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'failed to save data...Something went wrong!',
            })
        }finally{
            setIsSubmitted(false);
            closeModal();
        }
    }
    // useEffect(()=>{
    //     if(selectedSlabData){
    //         setPageTitle('Edit Slab Data');
    //         const modifiedData = {
    //             ...selectedSlabData,
                
    //         }
    //         setSlabData(modifiedData);
    //         reset(modifiedData,{isDirty:false});
    //         console.log("selected urban Data:",selectedSlabData)
    //     }
    // },[selectedSlabData])

    
    const Submitting = ()=>{
        Swal.fire({
            title: 'Please wait...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    }
    const resetFormField = ()=>{
        reset(slabInitialData);
        setSelectedSlabData(null);
        setSlabData(slabInitialData);
        setPageTitle('Add Slab');
        setPaginationModel({
            ...paginationModel,
            filters: {
            ...paginationModel.filters,
            searchKey: "",
            sortBy: 'createdAt',
            sortType: 'desc',
            filterOptions: []
            }
        });
    }    
    useEffect(()=>{
        fetchCategoryList();
        fetchUrbanTypeList();
    },[])

    const category = watch('categoryId');
    const subscriptionRegion = watch('SubscriptionUrbanTypeId');
    const lastSlabDetails = async () =>{
        const response = await SlabServices.fetchlastSlabDetails(category,subscriptionRegion);
        if(response.success== '1'){
            if(response.data?.orderEnd){
                setValue('orderStart',parseInt(response.data.orderEnd) + 1);
            }
        } else{
            setValue('orderStart',0);
        }
    }
    useEffect(()=>{
        if(category && subscriptionRegion){
            setPaginationModel({
                ...paginationModel,
                filters: {
                ...paginationModel.filters,
                searchKey: "",
                sortBy: 'createdAt',
                sortType: 'desc',
                filterOptions: [
                        {
                            "fieldName": "categoryId",
                            "operator": "equals",
                            "value": category,
                            "andOr": "and"
                        },
                        {
                            "fieldName": "SubscriptionUrbanTypeId",
                            "operator": "equals",
                            "value": subscriptionRegion,
                            "andOr": "and"
                        }
                    ]
                }
            });
            if(!selectedSlabData){
                lastSlabDetails();
            }
        }
    },[category,subscriptionRegion]);
    const subscriptionFee = watch('subscriptionFee');
    useEffect(()=>{
        if(subscriptionFee){
            const gstAmount = Math.round(subscriptionFee * 0.18);
            const totalAmount = parseInt(subscriptionFee) + gstAmount;
            setValue('subscriptionFeeWithGst',totalAmount);
        }else{
            setValue('subscriptionFeeWithGst',0);
        }
    },[subscriptionFee]);
  return (
    <PermissionGuard feature="gst" permission={selectedSlabData ?'canEdit':"canCreate"} fallback={selectedSlabData && <UnauthorizedPage/>}>
        <Card>
            {isSubmitted && Submitting()}
            <Box sx={{p:'1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
                <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >{pageTitle}</Typography>
            </Box>
            <Box component={'form'} onSubmit={handleSubmit(onSubmit)} sx={{p:1}}>
                
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Service Category <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Box sx={{display:'flex',alignItems:'center',gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                            <Controller
                                name='categoryId'
                                control={control}
                                rules={{ required: 'select category' }}
                                render={({ field, fieldState: { error } }) => (
                                    <Autocomplete
                                        fullWidth
                                        options={categoryList}
                                        getOptionLabel={(option) => option?.title || ''}
                                        isOptionEqualToValue={(option, value) =>
                                            option.id === value?.id || option.id === value
                                        }
                                        value={categoryList.find(cat => cat.id === field.value) || null}
                                        onChange={(event, newValue) => {
                                            let finalValue = newValue?.id || null;
                                            field.onChange(finalValue);
                                        }}
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label="Select SAC Code*"
                                                placeholder='Search and Select Category'
                                                error={!!error}
                                                // helperText={error ? error.message : ''}
                                                size="small"
                                                inputProps={{
                                                    ...params.inputProps,
                                                    style: { fontSize: '0.75rem' }
                                                }}
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                {option.title || ''}
                                            </MenuItem>
                                        )}
                                    />
                                )}
                            />
                            {loadingCategoryList && <CircularProgress />}
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600 }}>Subscription Type <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box> : </Typography>
                        <Controller
                            name='SubscriptionUrbanTypeId'
                            control={control}
                            rules={{
                                required: 'please select one urban type'
                            }}
                            render={({field,fieldState:{error}})=>
                                <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                    <Select
                                        {...field}
                                        error={!!error}
                                        sx={{
                                            fontSize:'0.65rem',
                                        }}
                                    >    
                                    {
                                        urbanTypeList && urbanTypeList.length> 0 && urbanTypeList.map(urban=>(
                                            <MenuItem key={urban.id} value={urban.id} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>{urban.typeTitle}</MenuItem>
                                        ))
                                    }                                
                                    </Select>
                                </FormControl>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:2}}>
                        <Button 
                            variant='contained' 
                            size='small' 
                            color='error'
                            onClick={resetFormField}
                            sx={{textTransform:'none'}}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant='contained' 
                            size='small' 
                            type='submit'
                            disabled={!isDirty}
                            sx={{textTransform:'none'}}
                        >
                            Copy & Save
                        </Button>
                    </Grid>
                </Grid>
                
                
            </Box>
        </Card>
    </PermissionGuard>
  );
}

export default SelectCategoryForm;